export const TENANT_MODULES = ['STORE', 'B2B_ORDERS', 'PRODUCTION', 'SECOND_HAND'] as const;

export type TenantModule = typeof TENANT_MODULES[number];

export const MODULE_ROUTES: Record<TenantModule, string[]> = {
  B2B_ORDERS: ['/orders', '/insights/payments'],
  PRODUCTION: ['/production', '/production-orders', '/providers', '/stock', '/inventory', '/insights/orders'],
  SECOND_HAND: ['/commission/drops', '/commission/settings', '/insights/commission-contracts'],
  STORE: ['/calendar', '/bookings', '/sales', '/customers', '/insights/meetings'],
};

export type SubmenuItemWithModule = {
  module?: TenantModule;
};

export type MenuItemWithModule = {
  module?: TenantModule;
  submenuItems?: Array<SubmenuItemWithModule>;
};

export const filterMenuItemsByModules = <T extends MenuItemWithModule>(
  items: T[],
  enabledModules: TenantModule[] | string[] | null | undefined,
): T[] => {
  return items
    .map((item) => {
      if (item.module && !isModuleEnabled(enabledModules, item.module)) {
        return null;
      }
      if (item.submenuItems) {
        const filteredSubmenu = item.submenuItems.filter(
          (sub) => !sub.module || isModuleEnabled(enabledModules, sub.module),
        );
        if (filteredSubmenu.length === 0) {
          return null;
        }
        return { ...item, submenuItems: filteredSubmenu } as T;
      }
      return item;
    })
    .filter((item): item is T => item !== null);
};

export const isModuleEnabled = (enabledModules: TenantModule[] | string[] | null | undefined, module: TenantModule) => {
  return !enabledModules || enabledModules.length === 0 || (enabledModules as string[]).includes(module);
};

export const getPersistedEnabledModules = (enabledModules: TenantModule[]) => {
  return enabledModules.length === TENANT_MODULES.length ? [] : enabledModules;
};
